
import Vue from 'vue';
import Component from 'vue-class-component';
import rely from '@/nmb/oauth2/oauth2rely';
import config from "@/params/config";
import axios from "axios";
import { Action, Getter } from 'vuex-class';

@Component
export default class ProdcutSupport extends Vue {

  action: string = config.neo +"/ProductSupport/Import";
  importloading:Boolean=false;

  // 上传出错
  handleError(err: any, file: any) {
    this.$message.error(`文件${file.name}上传失败`);
    this.importloading = false;
  }
  // 上传成功
   handleSuccess(response: any, file: any, fileList: any) {
    this.importloading = false;
    if(response.Success){
      this.$message.success(`文件${file.name}上传成功`);
    }else{
      this.$message.error(response.Message);
    }
   }

  // 准备上传
  handlerBeforeUpload(file: any) {
    if (file.size > 1024 * 1024 * 20) {
      this.$message({ type: "warning", message: `文件上传限制为20M` });

      return false;
    } else if (file.size === 0) {
      this.$message({ type: "warning", message: `文件${file.name}大小为空` });
    }
    this.importloading = true;
  }


  eport(){
    const fileName='产品对接人.xlsx';
    const tokens = rely.getTokens();
    const axiosConfig = {
      method: "get",
      url: `${config.neo}/ProductSupport/Export`,
      headers: {
        Authorization: `Bearer ${tokens.access_token}`
      },
      responseType: "blob"
    };

    axios(axiosConfig)
      .then(res => {        
        const blob = res.data;
        if(blob.size<200){
          this.$message.error(`文件${fileName}下载失败`);
          return;
        }
        if (window.navigator.msSaveBlob) {
          // IE10+ 使用的下载方式
          return window.navigator.msSaveBlob(blob, fileName);
        }
        // 其他浏览器下载方式
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e: any) => {
          const a: any = document.createElement("a");
          a.download = fileName;
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      })
      .catch((err: any) => {
        this.$message.error(`文件${fileName}下载失败`);
      });            
  }

}
